const HelpIndex = () => import('@/views/Dashboard/Help/HelpIndex');
const HelpArticle = () => import('@/views/Dashboard/Help/HelpArticle');

// Not permission-gated: a user who can reach a screen can read how to use it. Individual articles
// still hide themselves when the tenant does not have the feature they describe.
export default [
  {
    path: '/help',
    name: 'help',
    component: HelpIndex,
  },
  {
    path: '/help/:id',
    name: 'help-article',
    component: HelpArticle,
  },
];
